'use client';

import { usePageLayout } from '@libs/common-next';
import './UnexpectedErrorAlert.scss';
import {
    TextPassage,
    AlertBody,
    LayoutLinelengthContainer,
    Heading,
    Alert,
} from '@petsmart-ui/sparky';
import { useEffect } from 'react';
import { trackError } from '@libs/analytics';
import { ERROR_ALERT } from './constants';

export default function UnexpectedErrorAlert() {
    const {
        errorAlert,
        setErrorAlert,
        isInventoryError,
        setIsInventoryError,
        pageType,
        refreshNeededError,
        setRefreshNeededError,
    } = usePageLayout();

    const errorMessage = {
        heading: ERROR_ALERT.UNEXPECTED_ERROR_HEADING,
        body: ERROR_ALERT.UNEXPECTED_ERROR_BODY,
    };

    if (isInventoryError) {
        errorMessage.heading = ERROR_ALERT.INVENTORY_ERROR_HEADING;
        errorMessage.body = ERROR_ALERT.INVENTORY_ERROR_BODY;
    }

    if (refreshNeededError) {
        errorMessage.heading = ERROR_ALERT.REFRESH_NEEDED_ERROR_HEADING;
        errorMessage.body = ERROR_ALERT.REFRESH_NEEDED_ERROR_BODY;
    }

    useEffect(() => {
        let timerId: NodeJS.Timeout | undefined;

        if (errorAlert) {
            trackError(pageType?.toUpperCase(), errorMessage.body);

            timerId = setTimeout(() => {
                setErrorAlert(false);
                setIsInventoryError(false);
                setRefreshNeededError(false);
            }, 5000);

            window.scrollTo({ top: 1, behavior: 'smooth' });
        }

        return () => {
            if (timerId) {
                clearTimeout(timerId);
                setErrorAlert(false);
                setIsInventoryError(false);
                setRefreshNeededError(false);
            }
        };
    }, [
        errorAlert,
        pageType,
        setErrorAlert,
        setIsInventoryError,
        setRefreshNeededError,
        errorMessage.body,
    ]);

    return errorAlert ? (
        <div className="unexpected-error" data-testid="test-unexpected-error">
            <Alert iconName="exclamation-circle-fill" variant="error">
                <AlertBody>
                    <LayoutLinelengthContainer>
                        <Heading size="body-bold" tagName="h2">
                            {errorMessage.heading}
                        </Heading>
                    </LayoutLinelengthContainer>
                    <TextPassage>
                        <p>{errorMessage.body}</p>
                    </TextPassage>
                </AlertBody>
            </Alert>
        </div>
    ) : null;
}
